import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@savvy-kit/components/select';

import type { PerformanceTimePeriodName as TimePeriodType } from '@savvy/constants/generated/gql-enums';
import {
  PERFORMANCE_TIME_PERIOD_ALL_TIME,
  PERFORMANCE_TIME_PERIOD_PAST_MONTH,
  PERFORMANCE_TIME_PERIOD_PAST_THREE_MONTHS,
  PERFORMANCE_TIME_PERIOD_PAST_YEAR,
  PERFORMANCE_TIME_PERIOD_YEAR_TO_DATE,
} from '@savvy/constants/performance-time-periods';

export const DEFAULT_DATE_RANGE_OPTIONS: {
  value: TimePeriodType;
  label: string;
}[] = [
  {
    value: PERFORMANCE_TIME_PERIOD_ALL_TIME,
    label: 'All Time',
  },
  { value: PERFORMANCE_TIME_PERIOD_PAST_YEAR, label: '1 Year' },
  { value: PERFORMANCE_TIME_PERIOD_YEAR_TO_DATE, label: 'YTD' },
  {
    value: PERFORMANCE_TIME_PERIOD_PAST_THREE_MONTHS,
    label: '3 Month',
  },
  { value: PERFORMANCE_TIME_PERIOD_PAST_MONTH, label: '1 Month' },
];

type DateRangeOption = {
  value: TimePeriodType;
  label: string;
};

export function DateRangeSelect({
  quickDate,
  setQuickDate,
  disabled,
  width,
  dateRangeOptions = DEFAULT_DATE_RANGE_OPTIONS,
}: {
  readonly quickDate: TimePeriodType;
  readonly setQuickDate: (value: TimePeriodType) => void;
  readonly disabled?: boolean;
  readonly width?: string;
  readonly dateRangeOptions?: DateRangeOption[];
}) {
  return (
    <Select value={quickDate} items={dateRangeOptions} onValueChange={setQuickDate} disabled={!!disabled}>
      <SelectTrigger id="date-range-select" size="sm" style={{ width: width || '144px' }}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {dateRangeOptions.map((item) => (
          <SelectItem key={item.value} value={item.value}>
            {item.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
